import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../app/Layout";
import MaterialtableDemo from "../../components/plugins/MaterialTableDemo";
import SpinnerLoading from "../../components/Spinners/SpinnerLoading";
import Voucher from "../Contratos/Voucher";
import {
  updateStateModalBasic,
  updateStateModalCustom,
  updateStateModalLarge,
} from "../../../actions/modalActions";
import { listarVouchers } from "../../../actions/pagosActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileImport, faUpload, faEye, faLock } from "@fortawesome/free-solid-svg-icons";


import "./Vouchers.scss";
import ColumnVisibilityModal from "../../components/Utils/Modals/ColumnVisibilityModal";
import AddNewVoucherModal from "./AddNewVoucherModal";
import ModalBasicwithRedux from "../../../containers/ModalBasicwithRedux";
import ModalLargewhithRedux from "../../../containers/ModalLargewhithRedux";
import ModalCustomWidthwithRedux from "../../../containers/ModalCustomWidthwithRedux";

// src/view/pages/Vouchers/Vouchers.js
// Componente inicial para la página Vouchers (sin lógica)

const Vouchers = ({ id_proyecto, filtroEstado = '', filtroAnio = '', filtroMes = '' }) => {
  //State
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [shouldRefetch, setShouldRefetch] = useState(false);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [previewVoucher, setPreviewVoucher] = useState(null);
  const [previewVoucherList, setPreviewVoucherList] = useState(null);
  const [paginaActual, setPaginaActual] = useState(1);
  const [busqueda, setBusqueda]         = useState('');
  const [busquedaApi, setBusquedaApi]   = useState('');
  const debounceRef = useRef(null);
  const LIMITE = 50;

  const vouchers          = useSelector((state) => state.boletas.vouchers);
  const paginacion        = useSelector((state) => state.boletas.vouchersPaginacion);
  const loadingVouchers   = useSelector((state) => state.boletas.loading);
  const usuario = useSelector((state) => state.usuario?.usuario || state.usuario || null);

let rol = usuario?.nombre_tp_nivel_usuario?.trim().toUpperCase() || "";

if (rol === "VENTA") rol = "VENTAS";
if (rol === "EXPERIENCIA") rol = "EXPCLIENTE";

// Ventas solo ve sus clientes — pasa su id_usuario al SP
// Jefe de ventas, Operaciones, Finanzas, etc. ven todos (id = 0)
const idUsuarioFiltro = rol === "VENTAS"
  ? Number(usuario?.id_usuario || usuario?.id || 0)
  : 0;



  const handleModalNuevo = (ruta) => {
    dispatch(updateStateModalBasic(<Voucher rutaImagen={ruta} />, "Voucher"));
  };

  // Abre modal para agregar/subir voucher cuando no existe
  const handleAddVoucher = (record) => {
  // Construir el array de archivos existentes
  const archivosExistentes = vouchers.filter(
  v => v.id_dt_matricula_proyecto === record.id_dt_matricula_proyecto
);
  
  const esFinanzas = usuario?.nombre_tp_nivel_usuario?.trim().toUpperCase() === "FINANZAS";
const areaRegistro = esFinanzas ? null : (record?.area_registro || null);


  dispatch(
  updateStateModalLarge(
    <AddNewVoucherModal
      onClose={handleCloseModal}
      id_dt_matricula_proyecto={record.id_dt_matricula_proyecto}
      tp_cuota={record.tp_cuota}
      archivosExistentes={archivosExistentes}
      areaRegistro={areaRegistro}
      onVoucherDeleted={() => setShouldRefetch(true)}
    />,
    esFinanzas ? "" : "Agregar voucher"
  )
);

};
  const toggleColumn = (columnName) => {
    const updatedVisibility = {
      ...columnVisibility,
      [columnName]: !columnVisibility[columnName],
    };
    setColumnVisibility(updatedVisibility);
    localStorage.setItem("columnVisibility", JSON.stringify(updatedVisibility));
  };

  const handleCloseModal = () => {
  dispatch(updateStateModalLarge());
};

  const handleBusqueda = (e) => {
    const val = e.target.value;
    setBusqueda(val);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setPaginaActual(1);
      setBusquedaApi(val.trim());
    }, 500);
  };

const handleCloseColumnModal = () => {
  setShowModal(false);
};


  const handleShowModal = () => setShowModal(true);

  

 const idProyectoLimpio =
    id_proyecto && id_proyecto !== "null" ? Number(id_proyecto) : 0;

 // resetear página cuando cambia cualquier filtro
 useEffect(() => {
   setPaginaActual(1);
 }, [idProyectoLimpio, busquedaApi, filtroAnio, filtroMes, filtroEstado]);

 useEffect(() => {
  if (!usuario) return;

  const fetchData = async () => {
    await dispatch(listarVouchers(
      idProyectoLimpio, 1, idUsuarioFiltro, paginaActual, LIMITE,
      busquedaApi,
      filtroAnio  ? Number(filtroAnio)  : 0,
      filtroMes   ? Number(filtroMes)   : 0,
      filtroEstado? Number(filtroEstado): 0
    ));
  };

  fetchData();
  setShouldRefetch(false);

  const savedVisibility = localStorage.getItem("columnVisibility");
  if (savedVisibility) {
    setColumnVisibility(JSON.parse(savedVisibility));
  }
}, [dispatch, usuario, idProyectoLimpio, shouldRefetch, paginaActual, busquedaApi, filtroAnio, filtroMes, filtroEstado]);




  const visibleColumns = colums(
  handleModalNuevo,
  handleAddVoucher,
  usuario,
  vouchers,
  setPreviewVoucher,
  setPreviewVoucherList
)


    // oculta columnas marcadas manualmente en el modal
    .filter((column) => !columnVisibility[column.key])
    // aplica restricción por rol si la columna define rolesAllowed
    .filter((column) => {
      if (!column.rolesAllowed || !Array.isArray(column.rolesAllowed)) return true;
      const userRole = usuario?.nombre_tp_nivel_usuario;

      return userRole ? column.rolesAllowed.includes(String(userRole).toUpperCase()) : false;
    });

  const tablaFiltrada = Object.values(
    vouchers.reduce((acc, item) => {
      if (!acc[item.id_dt_matricula_proyecto]) {
        acc[item.id_dt_matricula_proyecto] = item;
      }
      if (item.archivo_voucher) {
        acc[item.id_dt_matricula_proyecto].tiene_voucher = true;
      }
      return acc;
    }, {})
  )
  .sort((a, b) => {
    const aTiene = a.tiene_voucher ? 1 : 0;
    const bTiene = b.tiene_voucher ? 1 : 0;
    return bTiene - aTiene;
  });

  return (
    <div className="vouchers-container">
      <SpinnerLoading loading={loadingVouchers}>
        <div className="box mt-3">
          <div className="m-3">
            <button className="btn btn-primary" onClick={handleShowModal}>
              Columnas
            </button>
          </div>
          <div className="box-primary">
            <div className="px-1 mb-2" style={{ fontSize: '13px', color: '#666' }}>
              Total: <strong>{paginacion.total}</strong> registros —
              Página <strong>{paginacion.pagina}</strong> de <strong>{paginacion.paginas}</strong>
            </div>
            <MaterialtableDemo
              columns={visibleColumns}
              tabla={tablaFiltrada}
              keyCol="id_dt_matricula_proyecto"
              addConfig={{ pagination: false }}
              onSearch={handleBusqueda}
            />
            <PaginacionServidor
              pagina={paginaActual}
              paginas={paginacion.paginas}
              total={paginacion.total}
              loading={loadingVouchers}
              onChange={setPaginaActual}
            />
          </div>
          <ModalBasicwithRedux />
          <ModalLargewhithRedux />
        </div>
        <ColumnVisibilityModal
          show={showModal}
          onClose={handleCloseColumnModal}
          columns={colums(handleModalNuevo, handleAddVoucher, usuario, vouchers, setPreviewVoucher, setPreviewVoucherList)}
          columnVisibility={columnVisibility}
          onToggleColumn={toggleColumn}
        />
            </SpinnerLoading>
{previewVoucherList && (
  <div
    className="position-fixed d-flex align-items-center justify-content-center"
    style={{
      inset: 0,
      zIndex: 9999,
      backgroundColor: "rgba(0, 0, 0, 0.65)",
      padding: "24px"
    }}
    onClick={() => setPreviewVoucherList(null)}
  >
    <div
      className="bg-white rounded position-relative"
      style={{
        width: "90vw",
        maxWidth: "1000px",
        maxHeight: "90vh",
        overflowY: "auto",
        padding: "28px"
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        className="btn btn-light btn-sm position-absolute"
        style={{ top: "10px", right: "10px", zIndex: 2 }}
        onClick={() => setPreviewVoucherList(null)}
      >
        Cerrar
      </button>

      <h5 className="mb-4">Vouchers</h5>

      <div
  className="d-flex flex-wrap justify-content-center"
  style={{ gap: "24px" }}
>

        {previewVoucherList.archivos.map((archivo, index) => {
          const url = `${process.env.REACT_APP_API_URL}/files_vouchers/${archivo.archivo_voucher}`;
          const esPdf = archivo.archivo_voucher?.toLowerCase().endsWith(".pdf");

          return (
            <div key={`${archivo.archivo_voucher}-${index}`} style={{ width: "320px" }}>
              {esPdf ? (
                <PdfPreviewFrame
  url={url}
  title={`Voucher ${index + 1}`}
  style={{
    width: "320px",
    height: "320px",
    border: "1px solid #dee2e6",
    borderRadius: "6px"
  }}
/>

              ) : (
                <img
                  src={url}
                  alt="voucher"
                  style={{
                    width: "320px",
                    height: "320px",
                    objectFit: "contain",
                    border: "1px solid #dee2e6",
                    borderRadius: "6px",
                    backgroundColor: "#f8f9fa",
                    cursor: "zoom-in"
                  }}
                  onClick={() => setPreviewVoucher({ url, name: archivo.archivo_voucher, type: "image/jpeg" })}
                />
              )}

              <div className="mt-2 text-muted" style={{ fontSize: "12px" }}>
                <div>
                  <strong>Fecha:</strong> {archivo.fecha_registro || "No registrada"}
                </div>
                <div>
                  <strong>Subido por:</strong> {archivo.usuario_registro || "No registrado"}
                </div>
                <div>
                  <strong>Área:</strong> {String(archivo.area_registro) === "1" ? "Experiencia" : "Ventas"}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </div>
)}

      {previewVoucher && (
        <div
          className="position-fixed d-flex align-items-center justify-content-center"
          style={{
            inset: 0,
            zIndex: 9999,
            backgroundColor: "rgba(0, 0, 0, 0.65)",
            padding: "24px"
          }}
          onClick={() => setPreviewVoucher(null)}
        >
          <div
            className="position-relative"
            style={{ maxWidth: "92vw", maxHeight: "92vh" }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="btn btn-light btn-sm position-absolute"
              style={{ top: "10px", right: "10px", zIndex: 2 }}
              onClick={() => setPreviewVoucher(null)}
            >
              Cerrar
            </button>

            {previewVoucher.type?.includes("pdf") || previewVoucher.name?.toLowerCase().endsWith(".pdf") ? (
              <PdfPreviewFrame
  url={previewVoucher.url}
  title="Vista previa PDF"
  style={{
    width: "88vw",
    height: "88vh",
    border: "0",
    borderRadius: "6px",
    backgroundColor: "transparent"
  }}
/>

            ) : (
              <img
                src={previewVoucher.url}
                alt="Vista previa voucher"
                style={{
                  maxWidth: "88vw",
                  maxHeight: "88vh",
                  objectFit: "contain",
                  borderRadius: "6px",
                  backgroundColor: "transparent"
                }}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const PdfPreviewFrame = ({ url, title, style }) => {
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

  useEffect(() => {
    let objectUrl = null;

    const loadPdf = async () => {
      try {
        const response = await fetch(url);
        const blob = await response.blob();

        objectUrl = URL.createObjectURL(blob);
        setPdfBlobUrl(objectUrl);
      } catch (error) {
        setPdfBlobUrl(null);
      }
    };

    loadPdf();

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [url]);

  if (!pdfBlobUrl) {
    return (
      <div
        style={{
          ...style,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f8f9fa",
          color: "#dc3545",
          fontWeight: 700
        }}
      >
        PDF
      </div>
    );
  }

  return (
    <iframe
      src={`${pdfBlobUrl}#toolbar=0&navpanes=0&scrollbar=0`}

      title={title}
      style={style}
    />
  );
};

const PaginacionServidor = ({ pagina, paginas, total, loading, onChange }) => {
  if (!paginas || paginas <= 0) return null;

  const delta = 2;
  const left  = Math.max(2, pagina - delta);
  const right = Math.min(paginas - 1, pagina + delta);

  const items = [];
  items.push(1);
  if (left > 2) items.push('...');
  for (let i = left; i <= right; i++) items.push(i);
  if (right < paginas - 1) items.push('...');
  if (paginas > 1) items.push(paginas);

  return (
    <div
      className="d-flex justify-content-between align-items-center px-1 py-2 mt-1"
      style={{ borderTop: '1px solid #e9ecef', flexWrap: 'wrap', gap: '8px' }}
    >
      <span />
      <div className="d-flex align-items-center" style={{ gap: '3px', flexWrap: 'wrap' }}>
        <button
          className="btn btn-sm btn-outline-secondary"
          disabled={pagina <= 1 || loading}
          onClick={() => onChange(pagina - 1)}
          style={{ minWidth: '32px' }}
        >‹</button>

        {items.map((item, i) =>
          item === '...'
            ? <span key={`e${i}`} style={{ padding: '2px 4px', color: '#aaa', userSelect: 'none' }}>…</span>
            : <button
                key={item}
                className={`btn btn-sm ${item === pagina ? 'btn-primary' : 'btn-outline-secondary'}`}
                disabled={loading}
                onClick={() => onChange(item)}
                style={{ minWidth: '32px' }}
              >{item}</button>
        )}

        <button
          className="btn btn-sm btn-outline-secondary"
          disabled={pagina >= paginas || loading}
          onClick={() => onChange(pagina + 1)}
          style={{ minWidth: '32px' }}
        >›</button>
      </div>
    </div>
  );
};

export default Vouchers;

const colums = (handleModalNuevo, handleAddVoucher, usuario, vouchers = [], setPreviewVoucher, setPreviewVoucherList) => [


  {
    text: "ID",
    key: "id_dt_matricula_proyecto",
    className: "id_dt_matricula_proyecto",
    sortable: true,
  },
  {
    text: "Fecha de registro",
    key: "fecha_registro",
    className: "fecha_registro",
    sortable: true,
  },
  {
    text: "Producto",
    key: "producto",
    align: "center",
    sortable: true,
    className: "producto",
    cell: (record) => (
      <span>
        <strong>{record.id_producto}</strong> - {record.producto}
      </span>
    ),
  },
  {
    text: "Plan",
    key: "plan",
    align: "center",
    className: "plan",
    sortable: true,
  },
  {
    text: "Asesor",
    key: "asesor",
    align: "center",
    sortable: true,
    className: "asesor",
  },
  {
    text: "DNI",
    key: "dni",
    className: "dni",
    sortable: true,
  },
  {
    text: "Nombres",
    key: "nombres",
    className: "nombres",
    sortable: true,
  },
  {
    text: "Apellidos",
    key: "apellidos",
    className: "apellidos",
    sortable: true,
  },
  {
    text: "Celular",
    key: "celular",
    className: "celular",
    sortable: true,
  },
  {
    text: "Concepto",
    key: "concepto",
    className: "concepto",
    sortable: true,
  },
  {
    text: "Fecha límite",
    key: "fecha_limite",
    className: "fecha_limite",
    sortable: true,
    cell: (record) => {
      if (!record.fecha_limite) return <span style={{ color: '#ccc' }}>—</span>;
      const hoy     = new Date();
      const limite  = new Date(record.fecha_limite);
      const vencida = limite < hoy && Number(record.estado_voucher) !== 1;
      return (
        <span style={{ color: vencida ? '#E74C3C' : 'inherit', fontWeight: vencida ? 600 : 400 }}>
          {record.fecha_limite}
          {vencida && (
            <span style={{ marginLeft: 4, fontSize: 10, color: '#E74C3C' }}>⚠</span>
          )}
        </span>
      );
    },
  },
  {
    text: "Estado",
    key: "estado_voucher",
    className: "estado_voucher",
    sortable: true,
    cell: (record) => {
      const estado = Number(record.estado_voucher);
      const map = {
        1: { text: "Registrado", className: "badge bg-success" },
        2: { text: "Pendiente", className: "badge bg-warning text-dark" },
        3: { text: "Anulado", className: "badge bg-danger" },
      };
      const { text, className } = map[estado] || {
        text: "Desconocido",
        className: "badge bg-secondary",
      };
      return <span className={className}>{text}</span>;
    },
  },
  {
  text: "Voucher",
  key: "archivo_voucher",
  align: "center",
  className: "archivo_voucher",
  sortable: false,
  cell: (record) => {
    const archivos = vouchers.filter(
      v => v.id_dt_matricula_proyecto === record.id_dt_matricula_proyecto && v.archivo_voucher
    );

    const archivosPreview = archivos.slice(0, 2);
    const extras = archivos.length - archivosPreview.length;
    const esFinanzas = usuario?.nombre_tp_nivel_usuario?.trim().toUpperCase() === "FINANZAS";

    return (
      <div style={{ minWidth: "250px", padding: "8px 0" }}>
       

{esFinanzas && archivos.length === 0 && (
  <div
    className="mt-2"
    style={{
      fontSize: "12px",
      fontWeight: 600,
      color: "#8a97a8",
      textAlign: "left"
    }}
  >
    <span
      style={{
        display: "inline-block",
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: "#b8c2d1",
        marginRight: "6px"
      }}
    />
    Sin archivos adjuntos
  </div>
)}


        {(archivos.length > 0 || !esFinanzas) && (

          <>
            <div className="d-flex align-items-center mt-2" style={{ gap: "8px" }}>
  
  {!esFinanzas && (
    Number(record.estado_voucher) === 1 ? (
      <div
        title="Pago registrado — no se pueden agregar más vouchers"
        style={{
          width: "58px",
          height: "58px",
          border: "1px solid #e0e0e0",
          color: "#adb5bd",
          backgroundColor: "#f8f9fa",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "not-allowed"
        }}
      >
        <FontAwesomeIcon icon={faLock} />
      </div>
    ) : (
      <button
        type="button"
        className="btn btn-sm"
        style={{
          width: "58px",
          height: "58px",
          border: "1px dashed #2f5fb3",
          color: "#1f4f9e",
          backgroundColor: "#f8fbff",
          fontWeight: 700,
          borderRadius: "8px",
          padding: "0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
        onClick={() => handleAddVoucher(record)}
        title="Adjuntar voucher"
      >
        <FontAwesomeIcon icon={faUpload} />
      </button>
    )
  )}

              {archivosPreview.map((archivo, index) => {
                const url = `${process.env.REACT_APP_API_URL}/files_vouchers/${archivo.archivo_voucher}`;
                const esPdf = archivo.archivo_voucher?.toLowerCase().endsWith(".pdf");

                return (
                  <div
                    key={`${archivo.archivo_voucher}-${index}`}
                    style={{
                      width: "58px",
                      height: "58px",
                      border: "1px solid #dbe3ef",
                      borderRadius: "8px",
                      overflow: "hidden",
                      backgroundColor: "#f4f7fb",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    {esPdf ? (
                      <span
  style={{ fontSize: "11px", fontWeight: 700, color: "#dc3545", cursor: "pointer" }}
  onClick={() => setPreviewVoucher({
  url,
  name: archivo.archivo_voucher,
  type: "application/pdf"
})}

>
  PDF
</span>

                    ) : (
                      <img
  src={url}
  alt="voucher"
  style={{
    width: "100%",
    height: "100%",
    objectFit: "cover",
    cursor: "pointer"
  }}
  onClick={() => setPreviewVoucher && setPreviewVoucher({
  url,
  name: archivo.archivo_voucher,
  type: "image/jpeg"
})}
/>

                    )}
                  </div>
                );
              })}

              {extras > 0 && (
                <div
                  style={{
                    width: "58px",
                    height: "58px",
                    border: "1px dashed #b8c7dd",
                    borderRadius: "8px",
                    color: "#1f4f9e",
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#fbfdff"
                  }}
                >
                  +{extras}
                </div>
              )}
            </div>

            {archivos.length > 0 && (
              <button
                type="button"
                className="btn btn-sm mt-2"
                style={{
                  background: "linear-gradient(135deg, #1f4f9e, #2f5fb3)",
                  color: "white",
                  borderRadius: "20px",
                  padding: "4px 12px",
                  fontSize: "12px",
                  fontWeight: 600,
                  border: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  boxShadow: "0 2px 4px rgba(31,79,158,0.2)"
                }}
                onClick={() => setPreviewVoucherList({ archivos })}
              >
                <FontAwesomeIcon icon={faEye} />
                Ver archivos
                <span style={{
                  background: "rgba(255,255,255,0.25)",
                  borderRadius: "10px",
                  padding: "1px 7px",
                  fontSize: "11px",
                  fontWeight: 700
                }}>
                  {archivos.length}
                </span>
              </button>
            )}

          </>
        )}
        
      </div>
    );
  },
},

];
